<pbc-filter-preset
  [filter]="mitarbeiter.preset$ | async"
  [filters]="mitarbeiter.presets$ | async"
  [name]="mitarbeiter.search$ | async"
  (select)="mitarbeiter.setFilter($event)"
  (save)="mitarbeiter.writeFilter($event)"
  (delete)="mitarbeiter.deleteFilter($event)"
></pbc-filter-preset>
